import React, { memo } from "react";
import cs from "classnames";
import styles from "./placeholder.module.scss";

interface ProductTilePlaceholderProps {
  amount: number;
}

/**
 * ProductTilePlaceholder component
 * @param {number} amount - The number of placeholder tiles to render
 * @returns {React.ReactElement}
 */
const ProductTilePlaceholder: React.FC<ProductTilePlaceholderProps> = memo(
  ({ amount }) => {
    // Generate the items using Array.from for a more functional approach
    const items = Array.from({ length: amount }, (_, i) => (
      <div
        data-testid="tile-item-box"
        className={cs(styles.tileItemBox, "col-xs-6", "col-sm-4")}
        key={i}
      >
        <div className={cs(styles.tileImage, styles.shimmer)} />
        <div className={cs(styles.tileText, styles.shimmer)} />
        <div className={cs(styles.tileSubtext, styles.shimmer)} />
        <div className={cs(styles.tilePrice, styles.shimmer)} />
      </div>
    ));

    return (
      <div data-testid="tile-box" className={cs(styles.tileBox, "row")}>
        {items}
      </div>
    );
  }
);

export default ProductTilePlaceholder;

ProductTilePlaceholder.displayName = "ProductTilePlaceholder";
